import TempworkerDocumentOutlineAddressProofSvg from '@Img/tempworkerDocument/outline/AddressProof.svg?url';
import TempworkerDocumentOutlineCurriculumVitaeSvg from '@Img/tempworkerDocument/outline/CurriculumVitae.svg?url';
import TempworkerDocumentOutlineCustomSvg from '@Img/tempworkerDocument/outline/Custom.svg?url';
import TempworkerDocumentOutlineDiplomaSvg from '@Img/tempworkerDocument/outline/Diploma.svg?url';
import TempworkerDocumentOutlineDriverLicenceSvg from '@Img/tempworkerDocument/outline/DriverLicence.svg?url';
import TempworkerDocumentOutlineExperienceSvg from '@Img/tempworkerDocument/outline/Experience.svg?url';
import TempworkerDocumentOutlineIbanSvg from '@Img/tempworkerDocument/outline/Iban.svg?url';
import TempworkerDocumentOutlineIdentityCardSvg from '@Img/tempworkerDocument/outline/IdentityCard.svg?url';
import TempworkerDocumentOutlineIdentityPieceSvg from '@Img/tempworkerDocument/outline/IdentityPiece.svg?url';
import TempworkerDocumentOutlineIntroductionSvg from '@Img/tempworkerDocument/outline/Introduction.svg?url';
import TempworkerDocumentOutlineMissingDocSvg from '@Img/tempworkerDocument/outline/MissingDoc.svg?url';
import TempworkerDocumentOutlineMissingIdentitySvg from '@Img/tempworkerDocument/outline/MissingIdentity.svg?url';
import TempworkerDocumentOutlinePassportSvg from '@Img/tempworkerDocument/outline/Passport.svg?url';
import TempworkerDocumentOutlinePDFSvg from '@Img/tempworkerDocument/outline/PDF.svg?url';
import TempworkerDocumentOutlineQualificationSvg from '@Img/tempworkerDocument/outline/Qualification.svg?url';
import TempworkerDocumentOutlineResidentPermitSvg from '@Img/tempworkerDocument/outline/ResidentPermit.svg?url';
import TempworkerDocumentOutlineSkillSvg from '@Img/tempworkerDocument/outline/Skill.svg?url';
import TempworkerDocumentOutlineSocialCertificateSvg from '@Img/tempworkerDocument/outline/SocialCertificate.svg?url';

import TempworkerDocumentAddressProofSvg from '@Img/tempworkerDocument/AddressProof.svg?url';
import TempworkerDocumentCurriculumVitaeSvg from '@Img/tempworkerDocument/CurriculumVitae.svg?url';
import TempworkerDocumentCustomSvg from '@Img/tempworkerDocument/Custom.svg?url';
import TempworkerDocumentDiplomaSvg from '@Img/tempworkerDocument/Diploma.svg?url';
import TempworkerDocumentDriverLicenceSvg from '@Img/tempworkerDocument/DriverLicence.svg?url';
import TempworkerDocumentIbanSvg from '@Img/tempworkerDocument/Iban.svg?url';
import TempworkerDocumentIdentityCardSvg from '@Img/tempworkerDocument/IdentityCard.svg?url';
import TempworkerDocumentIdentityPieceSvg from '@Img/tempworkerDocument/IdentityPiece.svg?url';
import TempworkerDocumentMissingDocSvg from '@Img/tempworkerDocument/MissingDoc.svg?url';
import TempworkerDocumentMissingIdentitySvg from '@Img/tempworkerDocument/MissingIdentity.svg?url';
import TempworkerDocumentPassportSvg from '@Img/tempworkerDocument/Passport.svg?url';
import TempworkerDocumentResidentPermitSvg from '@Img/tempworkerDocument/ResidentPermit.svg?url';
import TempworkerDocumentSocialCertificateSvg from '@Img/tempworkerDocument/SocialCertificate.svg?url';

import DriverLicencePictoASvg from '@Img/driver-licence-picto/A.svg?url';
import DriverLicencePictoA1Svg from '@Img/driver-licence-picto/A1.svg?url';
import DriverLicencePictoA2Svg from '@Img/driver-licence-picto/A2.svg?url';
import DriverLicencePictoAMSvg from '@Img/driver-licence-picto/AM.svg?url';
import DriverLicencePictoBSvg from '@Img/driver-licence-picto/B.svg?url';
import DriverLicencePictoB1Svg from '@Img/driver-licence-picto/B1.svg?url';
import DriverLicencePictoBESvg from '@Img/driver-licence-picto/BE.svg?url';
import DriverLicencePictoCSvg from '@Img/driver-licence-picto/C.svg?url';
import DriverLicencePictoC1Svg from '@Img/driver-licence-picto/C1.svg?url';
import DriverLicencePictoC1ESvg from '@Img/driver-licence-picto/C1E.svg?url';
import DriverLicencePictoCESvg from '@Img/driver-licence-picto/CE.svg?url';
import DriverLicencePictoDSvg from '@Img/driver-licence-picto/D.svg?url';
import DriverLicencePictoD1Svg from '@Img/driver-licence-picto/D1.svg?url';
import DriverLicencePictoD1ESvg from '@Img/driver-licence-picto/D1E.svg?url';
import DriverLicencePictoDESvg from '@Img/driver-licence-picto/DE.svg?url';


class DynamicImgService {

	private registry = new Map([
		['TempworkerDocumentOutlineAddressProofSvg', TempworkerDocumentOutlineAddressProofSvg],
		['TempworkerDocumentOutlineCurriculumVitaeSvg', TempworkerDocumentOutlineCurriculumVitaeSvg],
		['TempworkerDocumentOutlineCustomSvg', TempworkerDocumentOutlineCustomSvg],
		['TempworkerDocumentOutlineDiplomaSvg', TempworkerDocumentOutlineDiplomaSvg],
		['TempworkerDocumentOutlineDriverLicenceSvg', TempworkerDocumentOutlineDriverLicenceSvg],
		['TempworkerDocumentOutlineExperienceSvg', TempworkerDocumentOutlineExperienceSvg],
		['TempworkerDocumentOutlineIbanSvg', TempworkerDocumentOutlineIbanSvg],
		['TempworkerDocumentOutlineIdentityCardSvg', TempworkerDocumentOutlineIdentityCardSvg],
		['TempworkerDocumentOutlineIdentityPieceSvg', TempworkerDocumentOutlineIdentityPieceSvg],
		['TempworkerDocumentOutlineIntroductionSvg', TempworkerDocumentOutlineIntroductionSvg],
		['TempworkerDocumentOutlineMissingDocSvg', TempworkerDocumentOutlineMissingDocSvg],
		['TempworkerDocumentOutlineMissingIdentitySvg', TempworkerDocumentOutlineMissingIdentitySvg],
		['TempworkerDocumentOutlinePassportSvg', TempworkerDocumentOutlinePassportSvg],
		['TempworkerDocumentOutlinePDFSvg', TempworkerDocumentOutlinePDFSvg],
		['TempworkerDocumentOutlineQualificationSvg', TempworkerDocumentOutlineQualificationSvg],
		['TempworkerDocumentOutlineResidentPermitSvg', TempworkerDocumentOutlineResidentPermitSvg],
		['TempworkerDocumentOutlineSkillSvg', TempworkerDocumentOutlineSkillSvg],
		['TempworkerDocumentOutlineSocialCertificateSvg', TempworkerDocumentOutlineSocialCertificateSvg],

		['TempworkerDocumentAddressProofSvg', TempworkerDocumentAddressProofSvg],
		['TempworkerDocumentCurriculumVitaeSvg', TempworkerDocumentCurriculumVitaeSvg],
		['TempworkerDocumentCustomSvg', TempworkerDocumentCustomSvg],
		['TempworkerDocumentDiplomaSvg', TempworkerDocumentDiplomaSvg],
		['TempworkerDocumentDriverLicenceSvg', TempworkerDocumentDriverLicenceSvg],
		['TempworkerDocumentIbanSvg', TempworkerDocumentIbanSvg],
		['TempworkerDocumentIdentityCardSvg', TempworkerDocumentIdentityCardSvg],
		['TempworkerDocumentIdentityPieceSvg', TempworkerDocumentIdentityPieceSvg],
		['TempworkerDocumentMissingDocSvg', TempworkerDocumentMissingDocSvg],
		['TempworkerDocumentMissingIdentitySvg', TempworkerDocumentMissingIdentitySvg],
		['TempworkerDocumentPassportSvg', TempworkerDocumentPassportSvg],
		['TempworkerDocumentResidentPermitSvg', TempworkerDocumentResidentPermitSvg],
		['TempworkerDocumentSocialCertificateSvg', TempworkerDocumentSocialCertificateSvg],

		['DriverLicencePictoASvg', DriverLicencePictoASvg],
		['DriverLicencePictoA1Svg', DriverLicencePictoA1Svg],
		['DriverLicencePictoA2Svg', DriverLicencePictoA2Svg],
		['DriverLicencePictoAMSvg', DriverLicencePictoAMSvg],
		['DriverLicencePictoBSvg', DriverLicencePictoBSvg],
		['DriverLicencePictoB1Svg', DriverLicencePictoB1Svg],
		['DriverLicencePictoBESvg', DriverLicencePictoBESvg],
		['DriverLicencePictoCSvg', DriverLicencePictoCSvg],
		['DriverLicencePictoC1Svg', DriverLicencePictoC1Svg],
		['DriverLicencePictoC1ESvg', DriverLicencePictoC1ESvg],
		['DriverLicencePictoCESvg', DriverLicencePictoCESvg],
		['DriverLicencePictoDSvg', DriverLicencePictoDSvg],
		['DriverLicencePictoD1Svg', DriverLicencePictoD1Svg],
		['DriverLicencePictoD1ESvg', DriverLicencePictoD1ESvg],
		['DriverLicencePictoDESvg', DriverLicencePictoDESvg],
	]);

	get map () {
		return this.registry;
	}
}

const dynamicImgServiceSingleton = new DynamicImgService();

export default function useDynamicImg (img: string) {
	return dynamicImgServiceSingleton.map.get(img);
}
